<template>

    <div class="overflow-y-scroll flex-1" id="timeline-container">

        <div class="p-32">
            <h2 class="text-body font-semibold mb-16 capitalize">{{ $t('applications.timeline') }}</h2>

            <loading v-if="fetchingTimeline"></loading>

            <ol v-else class="leading-normal">

                <li v-for="event in validEvents" :key="event.id">
                    <timeline-item :application="application" :event="event"></timeline-item>
                </li>

            </ol>
        </div>
    </div>

</template>

<script>
import Application from '../models/Application';
import * as timeline from '../services/TimelineService';
import * as comments from '../services/CommentService';
import * as interimComments from '../services/InterimCommentService';
import Loading from './ui/Loading.vue';
import TimelineEvent from '../models/TimelineEvent';
import Comment from '../models/Comment';
import {normalizeJson} from '../../shared/helpers';
import moment from 'moment';
import TimelineItem from './TimelineItem.vue';
import SvgIcon from './ui/SvgIcon.vue';
import InterimComment from '../models/InterimComment';
import eventbus from "../../shared/eventbus";
import * as extRequest from '../services/ExtensionRequestService';
import DataRetentionExtensionRequest from '../models/DataRetentionExtensionRequest';
import User from "../models/User";
import {useRepo} from "pinia-orm";

export default {
    components: {
        'loading': Loading,
        'timeline-item': TimelineItem,
        'svg-icon': SvgIcon,
    },
    props: {
        application: Application,
    },
    data: function () {
        return {
            fetchingTimeline: true,
            moment,
        };
    },
    computed: {
        events() {
            return [
                {
                    created_at: this.application.created_at,
                    source: this.application.source,
                    original_stage: this.application.original_stage,
                },
                ...useRepo(DataRetentionExtensionRequest).where('application_id', this.application.id).get().filter(i => i.accepted_at).map(i => {
                    i.created_at = i.accepted_at;
                    return i;
                }),
                ...useRepo(InterimComment).with('user').with('interim_user').where('application_id', this.application.id).get(),
                ...useRepo(Comment).with('user').where('application_id', this.application.id).get(),
                ...useRepo(TimelineEvent)
                    .with('eventable')
                    .with('user')
                    .where('action', action => action !== 'comments.created')
                    .where('application_id', this.application.id)
                    .get(),
            ].sort((a, b) => moment(a.created_at).isBefore(b.created_at) ? -1 : 1);
        },
        validEvents() {
            return this.events.filter(event => {
                return ![
                    'applications.created',
                    'applications.deleted',
                    'applications.rating_updated',
                    'applications.cv_created',
                    'applications.cv_updated',
                    'applications.cv_deleted',
                    'applications.motivation_created',
                    'applications.motivation_updated',
                    'applications.motivation_deleted',
                    'documents.updated',
                    'interviews.time_updated',
                    'interviews.location_updated',
                    'interviews.happened',
                    'contacts.created_and_sent',
                    'contacts.updated',
                    'contacts.deleted',
                    'contacts.sent',
                    'comments.created',
                    'comments.updated',
                    'comments.deleted',
                ].includes(event.action);
            });
        },
    },
    methods: {
        fetchTimeline() {
            this.fetchingTimeline = true;

            Promise.all([
                timeline.index(this.application.id)
                    .then(result => {
                        return useRepo(TimelineEvent).save(normalizeJson(result.data));
                    }),
                comments.getApplicationComments(this.application.id)
                    .then(result => {
                        return useRepo(Comment).save(normalizeJson(result.data));
                    }),
                interimComments.getInterimComments(this.application.id)
                    .then(({data}) => {
                        return useRepo(InterimComment).save(normalizeJson(data));
                    }),
                extRequest.indexForApplication(this.application.id, true)
                    .then(result => {
                        return useRepo(DataRetentionExtensionRequest).save(normalizeJson(result));
                    }),
            ]).then(inserts => {
                this.fetchingTimeline = false;
                this.$nextTick(() => {
                    document.dispatchEvent(new Event('loadCalendar'));
                    this.scrollToEnd();
                });
            });
        },

        scrollToEnd() {
            let content = document.getElementById('timeline-container');
            content.scrollTop = content.scrollHeight + 200;
        },
    },
    mounted() {
        this.fetchTimeline();

        eventbus.addEventListener('timeline-scroll', this.scrollToEnd);
    },
};
</script>
